import { useState, useEffect } from "react";

const navLinks = [
  { label: "Como funciona", href: "#abrir-empresa" },
  { label: "Serviços", href: "#servicos" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Depoimentos", href: "#depoimentos" },
  { label: "FAQ", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMenuOpen(false);
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16">
        {/* Logo */}
        <a
          href="#hero"
          onClick={(e) => handleAnchorClick(e, "#hero")}
          className="flex items-center gap-1 cursor-pointer"
        >
          <div className="w-7 h-7 bg-[#2563eb] rounded-md flex items-center justify-center">
            <span className="text-white font-black text-xs">ZB</span>
          </div>
          <span className={`font-bold text-xl tracking-tight ${scrolled ? "text-[#0f2044]" : "text-white"}`}>
            ZB Advisor
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleAnchorClick(e, link.href)}
              className={`px-3 py-2 text-sm font-medium rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-[#0f2044] hover:text-[#2563eb]"
                  : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* CTA Button */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="#contato"
            onClick={(e) => handleAnchorClick(e, "#contato")}
            className="bg-[#2563eb] hover:bg-[#1d4ed8] text-white text-sm font-semibold px-4 py-2 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            Falar com especialista
          </a>
        </div>

        {/* Mobile Toggle */}
        <button
          className={`md:hidden p-2 cursor-pointer ${scrolled ? "text-[#0f2044]" : "text-white"}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-1">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleAnchorClick(e, link.href)}
              className="text-sm font-medium text-[#0f2044] hover:text-[#2563eb] py-2.5 border-b border-gray-50 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contato"
            onClick={(e) => handleAnchorClick(e, "#contato")}
            className="mt-3 bg-[#2563eb] hover:bg-[#1d4ed8] text-white text-sm font-semibold px-4 py-2.5 rounded-full text-center transition-colors cursor-pointer"
          >
            Falar com especialista
          </a>
        </div>
      )}
    </header>
  );
}
